import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=440d7810"
import script from "./Specialty.vue?vue&type=script&lang=js"
export * from "./Specialty.vue?vue&type=script&lang=js"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=440d7810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports